import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const DesktopItem = styled('div')(({ $isFlex, $textAlignRight }) => ({
  display: $isFlex && 'inline-flex',
  alignItems: 'center',
  textAlign: $textAlignRight && 'right',
  margin: '0 2px',
}));

export const DesktopItemContainer = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));

export const ProductDetailsRow = styled('div')(({ theme, $isSavingsOffer }) => ({
  display: 'grid',
  gridTemplateColumns: `2fr repeat(${$isSavingsOffer ? 4 : 5}, 1fr)`,
  padding: theme.spacing(6),
  background: theme.palette.white.main,
  borderRadius: 6,
  alignItems: 'center',
}));
